<template>
    <div class="del-confirmation-modal-backdrop">
        <div class="del-confirmation-modal">
            <div class="del-confirmation-modal-content">
                Are You Sure You Want to Delete This Card?
            </div>
            <div class="modal-btns">
                <button @click="handleYes" class="yes-btn">
                    <span class="yes-btn-text">Yes</span>
                </button>
                <button @click="handleNo" class="no-btn">
                    <span class="no-btn-text">No</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ConfirmationModal',
        methods: {
            handleYes() {
                this.$emit('clicked-yes')
            },
            handleNo() {
                this.$emit('clicked-no')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .del-confirmation-modal-backdrop {
        position: fixed;

        top: 25%;
        left: 20%;
        z-index: 9999;

        .del-confirmation-modal {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background-color: #262626;
            border-radius: 15px;
            width: 1160px;
            height: 369px;

            .del-confirmation-modal-content {
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 44px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -1.76px;
            }

            .modal-btns {
                margin-top: 35px;
                text-align: center;
                display: flex;
                justify-content: center;
                gap: 50px;

                .yes-btn {
                    display: flex;
                    width: 122px;
                    padding: 11px 30px 12px 30px;
                    justify-content: center;
                    align-items: center;
                    flex-shrink: 0;
                    border-radius: 100px;
                    background: #cdeb09;
                    .yes-btn-text {
                        color: #000;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                    }
                }
                .no-btn {
                    display: flex;
                    width: 122px;
                    padding: 10px 25px 11px 20px;
                    justify-content: center;
                    align-items: center;
                    gap: 5px;
                    flex-shrink: 0;
                    border-radius: 100px;
                    border: 1px solid #cdeb09;
                    background: #262626;
                    .no-btn-text {
                        color: #cdeb09;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 120%;
                    }
                }
            }
        }
    }
</style>
